<script context="module">
    import { readable, derived } from 'svelte/store';

    function createPWADetector() {
        let browserValue = 'Unknown';
        let platformValue = 'Unknown';
        let isPWAInstalledValue = false;

        function detectBrowser() {
            const userAgent = navigator.userAgent.toLowerCase();

            if (userAgent.indexOf('edge') > -1 || userAgent.indexOf('edg/') > -1) {
                browserValue = 'Edge';
            } else if (userAgent.indexOf('chrome') > -1) {
                browserValue = 'Chrome';
            } else if (userAgent.indexOf('safari') > -1) {
                browserValue = 'Safari';
            } else if (userAgent.indexOf('firefox') > -1) {
                browserValue = 'Firefox';
            }
        }

        function detectPlatform() {
            const userAgent = navigator.userAgent.toLowerCase();
            const platformString = navigator.platform.toLowerCase();

            if (/iphone|ipad|ipod/.test(userAgent)) {
                platformValue = 'iOS';
            } else if (/android/.test(userAgent)) {
                platformValue = 'Android';
            } else if (/mac/.test(platformString)) {
                platformValue = 'macOS';
            } else if (/win/.test(platformString)) {
                platformValue = 'Windows';
            } else if (/linux/.test(platformString)) {
                platformValue = 'Linux';
            }
        }

        function checkPWAInstallation() {
            const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
            const isFullScreen = window.navigator.standalone;
            
            // Check if PWA was previously installed (for Chrome-based browsers)
            if (localStorage.getItem('pwaInstalled') === 'true') {
                isPWAInstalledValue = true;
                return;
            }

            // For iOS (both Safari and Chrome)
            if (platformValue === 'iOS') {
                isPWAInstalledValue = isFullScreen;
            }
            // For Android
            else if (platformValue === 'Android') {
                isPWAInstalledValue = isStandalone;
            }
            // For desktop browsers
            else if (['macOS', 'Windows', 'Linux'].includes(platformValue)) {
                if (browserValue === 'Chrome' || browserValue === 'Edge') {
                    // For Chrome-based browsers, we'll rely on the standalone mode check
                    isPWAInstalledValue = isStandalone;
                } else if (browserValue === 'Safari') {
                    isPWAInstalledValue = isStandalone || isFullScreen;
                }
            }

            // Fallback for other browsers/platforms
            if (!isPWAInstalledValue) {
                isPWAInstalledValue = isStandalone || isFullScreen || 
                                      document.referrer.includes('android-app://');
            }
        }

        function handleAppInstalled() {
            console.log('PWA was installed');
            isPWAInstalledValue = true;
            localStorage.setItem('pwaInstalled', 'true');
        }

        // Initialize detection
        if (typeof window !== 'undefined') {
            detectBrowser();
            detectPlatform();
            checkPWAInstallation();
            window.addEventListener('appinstalled', handleAppInstalled);
        }

        // Create readable stores
        const browser = readable(browserValue);
        const platform = readable(platformValue);
        const isPWAInstalled = readable(isPWAInstalledValue, set => {
            // This function will be called when the first subscriber subscribes
            const interval = setInterval(() => {
                checkPWAInstallation();
                set(isPWAInstalledValue);
            }, 1000); // Check every second

            return () => {
                clearInterval(interval);
                if (typeof window !== 'undefined') {
                    window.removeEventListener('appinstalled', handleAppInstalled);
                }
            };
        });

        return { browser, platform, isPWAInstalled };
    }

    export const { browser, platform, isPWAInstalled } = createPWADetector();

    // Derived store for debug information
    export const debug = derived(
        [browser, platform, isPWAInstalled],
        ([$browser, $platform, $isPWAInstalled]) => {
            return `Browser: ${$browser}, Platform: ${$platform}, isPWAInstalled: ${$isPWAInstalled}`;
        }
    );
</script>